import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/mensagemSistemaOperacaoAgricola/actions';

import MyForm from './form';

function MensagemSistemaOperacaoAgricola() {
  const redux = useSelector((state) => state.mensagemSistemaOperacaoAgricola);

  const header = useMemo(() => [], []);

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={dataInRequest}
      find={findData}
      remove={deleteData}
      form={MyForm}
      keys=""
      detach=""
    />
  );
}

export default MensagemSistemaOperacaoAgricola;
